// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24_b8","icon":"styles_icon__1istr"};